module.exports = __webpack_public_path__ + "05_medium_beige.7592fd05.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/05_medium_beige.png
// module id = ugDD
// module chunks = 0